module.exports = __webpack_public_path__ + "static/atlaskit-select-5b58528f18ad05928063ba485aa348a0.png";